// extracted by mini-css-extract-plugin
export default {"container":"StaffRegulators_container__ixfgH","header":"StaffRegulators_header__saIjW","title":"StaffRegulators_title__krSGU"};